module.exports = __webpack_public_path__ + "img/20210416.8836a392.png";